import React from 'react';
import createReactClass from 'create-react-class';
import PropTypes from 'prop-types';
import ImmutableRenderMixin from 'react-immutable-render-mixin';
import ImmutablePropTypes from 'react-immutable-proptypes';
import {Link} from 'react-router';
import {List} from 'immutable';
import {connect} from 'react-redux';
import {registry} from 'records';
import {Request, RequestsMixin, GET} from 'requests';
import {ResourcesMatching, Requesting, Done} from 'requests/components';
import KitFrame from 'components/KitFrame';
import {typefacesAdded} from '../utils/kit';
import DocumentationMixin from '../mixins/DocumentationMixin';
import {default as Spinner, SIZE_LARGE} from 'components/Spinner';

const mapStateToProps = (state, ownProps) => {
  const kitToken = ownProps.kitToken || ownProps.params.kitToken;

  return {
    kitToken,
    requests: state.requests,
    kitMutations: state.kitMutations,
  };
};

const DocumentationTypefacesController = createReactClass({
  propTypes: {
    dispatch: PropTypes.func.isRequired,
    kitToken: PropTypes.string.isRequired,
    requests: PropTypes.object.isRequired,
    kitMutations: ImmutablePropTypes.map,
  },

  mixins: [DocumentationMixin, RequestsMixin, ImmutableRenderMixin],

  componentWillMount() {
    this.setRequest({
      kit: new Request({
        method: GET,
        url: ['api', 'kits', this.props.kitToken],
      }),
    });

    this.setRequest({
      publications: new Request({
        method: GET,
        url: ['api', 'kits', this.props.kitToken, 'publications'],
      }),
    });

    this.setRequest({
      iconSettings: new Request({
        method: GET,
        url: ['api', 'kits', this.props.kitToken, 'icon-settings'],
      }),
    });

    this.setRequest({
      workingSetTypefaces: new Request({
        method: GET,
        url: ['api', 'kits', this.props.kitToken, 'working-set-typefaces'],
      }),
    });
  },

  resources() {
    const rm = this.resourceManager();

    return {
      kit: rm.type(this.requests.kit, 'kits').find({token: this.props.kitToken}),
      finishedPublications: rm.type(this.requests.publications, 'publications').all().filter(p => p.status === 'finished'),
      iconSettings: rm.type(this.requests.iconSettings, 'icon-settings').get(),
      workingSetTypefaces: rm.type(this.requests.workingSetTypefaces, 'working-set-typefaces').all(),
    };
  },

  renderUsingTypefacesOnWeb() {
    const {kit, iconSettings} = this.resources();

    return (
      <section className="kit-components-typefaces-use m-xs-b-xl" id="kit-components-typefaces-use">
        <h2 className="text-2x m-xs-b-0">Using your typefaces on the web</h2>
        <hr className="hr-lg m-xs-y-sm" />
        <p>
          Fort Awesome takes care of the set up (using CSS's <code>@font-face</code>) of using custom fonts on
          the web. If you are using Fort Awesome's CDN, all you need do is follow the <Link to={`/kits/${kit.token}/docs`}>
          getting started instructions</Link> to publish (or download) your
          kit and reference its updated embed code in your project.
        </p>
        <p>
          Once you are referencing your kit's assets, you have a couple of ways you can call your typefaces:
        </p>
        <article className="example m-xs-b-xl">
          <h3 className="text-lg">Referencing font names in your CSS rules (recommended)</h3>
          <p>
            Fort Awesome takes the names you gave your kit's typefaces and creates unique <code>font-family</code>
            names you can reference within your project's CSS. You have typographical control and can make broad
            rules so that as much or as little of your content renders in a specific font. Below are examples of
            rules to add to your CSS.
          </p>

          <div className="well bg-gray-lightest text-sm text-muted br-b-0 m-xs-b-0" role="alert">
            <p className="m-xs-b-0">
              This example contains typefaces which may not be in your kit
            </p>
          </div>
          <pre className="bg-gray-dark inset-darkest br-b p-xs-a-md">
            <code className="css">
              // I'm a broad reference<br />
              body {'{'}<br />
              &nbsp;&nbsp;font-family: "Lato";<br />
              &nbsp;&nbsp;...<br />
              {'}'}
            </code>
          </pre>

          <div className="well bg-gray-lightest text-sm text-muted br-b-0 m-xs-b-0" role="alert">
            <p className="m-xs-b-0">
              This example contains typefaces which may not be in your kit
            </p>
          </div>
          <pre className="bg-gray-dark inset-darkest br-b p-xs-a-md">
            <code className="css">
              // I'm a very specific reference<br />
              footer.app .about {'{'}<br />
              &nbsp;&nbsp;font-family: "Lato";<br />
              &nbsp;&nbsp;...<br />
              {'}'}
            </code>
          </pre>
        </article>
        <article className="example m-xs-b-xl">
          <h3 className="text-lg">Using utility classes in your HTML</h3>
          <p>
            Fort Awesome also creates some useful preset CSS rules and HTML class names to make it easier to
            display the right typeface in a pinch. After you publish your kit, you'll be able to add a unique
            per-typeface <code>class</code> attribute to any HTML element.
          </p>

          <div className="well bg-gray-lightest text-sm text-muted br-b-0 m-xs-b-0" role="alert">
            <p className="m-xs-b-0">
              This example contains typefaces which may not be in your kit
            </p>
          </div>
          <pre className="bg-gray-dark inset-darkest br-b p-xs-a-md">
            <code className="html">
              &lt;p class="{iconSettings.cssPrefix}-lato"&gt;<br />
              &nbsp;&nbsp;This text will be rendered in Lato<br />
              &lt;/p&gt;
            </code>
          </pre>

          <div className="well bg-gray-lightest text-sm text-muted br-b-0 m-xs-b-0" role="alert">
            <p className="m-xs-b-0">
              This example contains typefaces which may not be in your kit
            </p>
          </div>
          <pre className="bg-gray-dark inset-darkest br-b p-xs-a-md">
            <code className="html">
              &lt;p class="{iconSettings.cssPrefix}-lato"&gt;<br />
              &nbsp;&nbsp;This text will be rendered in Lato,<br />
              &nbsp;&nbsp;&lt;span class="{iconSettings.cssPrefix}-open-sans"&gt;
              while this text will be rendered in Open Sans
              &lt;/span&gt;<br />
              &lt;/p&gt;
            </code>
          </pre>
        </article>
      </section>
    );
  },

  renderTypefacesInKit() {
    const {kit, workingSetTypefaces} = this.resources();
    const groupedWorkingSetTypefaces = workingSetTypefaces.groupBy(workingSetTypeface => workingSetTypeface.family);
    const unpublishedTypefaces = typefacesAdded(this.props.kitMutations, this.props.kitToken)
      .map((request) => request.getIn(['record', 'typefaceId']));

    const typefacesList = groupedWorkingSetTypefaces.map((groupedList, index) => {
      const sortedList = groupedList.sortBy(record => record.weight);
      const workingSetTypeface = sortedList.first();
      const styleLength = sortedList.size;

      const typefacesStylesList = sortedList
        .filter((typeface) => {
          return !unpublishedTypefaces.includes(typeface.typeface);
        })
        .map((typeface, i) => {
          return (
            <div key={typeface.id} className="kit-typeface-pangram text-2x" style={{fontFamily: typeface.family, fontWeight: typeface.weight, fontStyle: typeface.style}}>
              When my six o’clock alarm buzzes, I require a pot of good java.
            </div>
          );
        });

      if (typefacesStylesList.size === 0) {
        return null;
      }

      return (
        <article key={workingSetTypeface.family} className="kit-typeface kit-typeface-arvo m-xs-b-xl">
          <div className="bg-body br-t well p-xs-a-lg m-xs-b-0">
            {typefacesStylesList}
          </div>

          <hr className="m-xs-y-md" />

          <h3 className="text-base text-muted m-xs-b-lg">
            {workingSetTypeface.family}
            <span className="pull-right font-weight-normal">{styleLength} {(styleLength > 1) ? 'styles' : 'style'}</span>
          </h3>

          <div className="well bg-gray-lightest text-sm text-muted br-b-0 m-xs-b-0">
            <h4 className="text-base m-xs-b-0 font-weight-normal">Using in CSS</h4>
          </div>
          <pre className="bg-gray-dark inset-darkest br-b p-xs-a-md">
            <code className="css">
              .element {'{'}<br />
              &nbsp;&nbsp;font-family: "{workingSetTypeface.family}";<br />
              &nbsp;&nbsp;...<br />
              &nbsp;&nbsp;// optional styling<br />
              &nbsp;&nbsp;font-weight: {workingSetTypeface.weight};<br />
              &nbsp;&nbsp;font-style: {workingSetTypeface.style};<br />
              {'}'}
            </code>
          </pre>

          <div className="well bg-gray-lightest text-sm text-muted br-b-0 m-xs-b-0">
            <h4 className="text-base m-xs-b-0 font-weight-normal">Using in HTML</h4>
          </div>
          <pre className="bg-gray-dark inset-darkest br-b p-xs-a-md">
            <code className="html">
              &lt;h2 class="{workingSetTypeface.cssClass}"&gt;I'm a heading using a utility class&lt;h2&gt;
            </code>
          </pre>
        </article>
      );
    });
    const kitFrameElement = (
      <KitFrame kitToken={kit.token}>
        <div>{[...typefacesList]}</div>
      </KitFrame>
    );
    const noTypefacesElement = (
      <div className="well bg-primary bg-img bg-img-icons p-xs-a-2x m-xs-b-lg text-xs-center">
        <h2 className="text-2x">This Kit Doesn't Have Any Typefaces</h2>
        <p className="lead m-xs-b-0 text-muted">Hey. It looks like you don't have any typefaces currently in this kit. Its pretty easy to <Link to={`/kits/${kit.token}/typefaces/new`} className="text-white">add some</Link> or even <Link to={`/kits/${kit.token}/typefaces/upload`} className="text-white">upload your own</Link>.</p>
      </div>
    );

    return (
      <section className="kit-components-typefaces-inventory m-xs-b-xl" id="kit-components-typefaces-inventory">
        <h2 className="text-2x m-xs-b-0">Typefaces in this kit</h2>
        <hr className="hr-lg m-xs-y-sm" />
        {(typefacesList.isEmpty()) ? noTypefacesElement : kitFrameElement}
      </section>
    );
  },

  renderTroubleshootingTypefaces() {
    return (
      <section className="kit-components-typefaces-troubleshooting" id="kit-components-typefaces-troubleshooting">
        <h2 className="text-2x m-xs-b-0">Troubleshooting Typefaces</h2>
        <hr className="hr-lg m-xs-y-sm" />
        <article className="typefaces-not-rendering m-xs-b-lg" id="typefaces-not-rendering">
          <h3 className="text-lg">My kit's typefaces aren't rendering properly on my site or app</h3>
          <p>
            If your typefaces aren't rendering properly, you'll want to check the following:
          </p>
          <ul>
            <li>Did you published all changes/updates to you kit?</li>
            <li>Did you either referenced your kit's embed code or the path to downloaded assets in your pages' <code>&lt;head&gt;</code>?</li>
            <li>Did you named your typefaces uniquely (to avoid different versions of a typefaces found on users' local operating systems)?</li>
            <li>Did you added the provided font-family names in your own CSS or used the utility HTML class names correctly?</li>
          </ul>
        </article>
      </section>
    );
  },

  renderUnpublishedChangesAlert() {
    let retval = null;

    const {kitMutations} = this.props;
    const {kit} = this.resources();
    const typefacesHaveBeenAdded = !typefacesAdded(kitMutations, kit.token).isEmpty();

    if (typefacesHaveBeenAdded) {
      retval = (
        <div className="alert alert-primary bg-body has-icon m-xs-b-xl">
          <i className="ficon ficon-lg ficon-warning alert-icon"></i>
          <p className="m-xs-b-0">Hmm, you&apos;ve added some typefaces that you haven&apos;t published yet. <strong>Publish to see them here</strong> and to use them in your project.</p>
        </div>
      );
    }

    return retval;
  },

  renderMain() {
    const {kit, finishedPublications} = this.resources();

    return (
      <div className="row">
        <div className="col-xs-3 col-xs-push-9 p-xs-l-xl">
          {this.renderNavigation(kit, {hasBeenPublished: !finishedPublications.isEmpty()})}
        </div>
        <div className="col-xs-9 col-xs-pull-3">
          {this.renderUnpublishedChangesAlert()}
          {this.renderTypefacesInKit()}
          {this.renderUsingTypefacesOnWeb()}
          {this.renderTroubleshootingTypefaces()}
        </div>
      </div>
    );
  },

  renderSpinner() {
    return (
      <div className="is-loading is-loading-documentation-typefaces m-xs-x-0 bg-body p-xs-a-xl br-a">
        <Spinner size={SIZE_LARGE} />
      </div>
    );
  },

  render() {
    return (
      <ResourcesMatching manager={this.resourceManager()}>
        <Requesting any={true} render={this.renderSpinner} />
        <Done all={true} render={this.renderMain} />
      </ResourcesMatching>
    );
  },
});

export default connect(mapStateToProps)(DocumentationTypefacesController);



// WEBPACK FOOTER //
// ./app/javascript/views/Kits/components/DocumentationTypefacesController.js